import { useQuery } from "@tanstack/react-query";

import { chatApi } from "@/features/messaging/services/chat.api";

export function useConversations() {
  return useQuery({
    queryKey: ["conversations"],
    queryFn: chatApi.getConversations,
  });
}
